import script from "./WhatsAppDocRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppDocRenderer.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppDocRenderer.vue?vue&type=style&index=0&id=0590649e&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0590649e"]])

export default __exports__